<template>
    <div class="container is-fluid">
        <loading :active.sync="isBusy"
                 :can-cancel="false"
                 :is-full-page="true"></loading>

        <Nav style="margin-bottom: 20px;" />
        <div class="container is-fluid">
            <div class="columns">
                <div class="column is-12" style="margin-top: 70px;">
                    <template>
                        <div class="level">

                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-icon">
                                    <b-icon icon="view-compact"></b-icon>
                                </div>
                                <div class="level-item">
                                    <h4 class="title is-4">{{ $route.name }}</h4>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template>
                        <div class="content is-desktop">
                            <div class="box has-background-light" style="padding:15px">
                                <div>
                                    <b-field label="Mail">
                                        <b-input v-model="mailview.user"></b-input>
                                    </b-field>
                                    <b-field label="Password">
                                        <b-input v-model="mailview.password"></b-input>
                                    </b-field>
                                    <b-field label="Port">
                                        <b-input type="number" v-model="mailview.portEntry"></b-input>
                                    </b-field>
                                    <b-field label="TemplateBody" class="control is-clearfix">
                                        <textarea rows="8"
                                                  v-model="mailview.templateBody"
                                                  style="resize: none;width:100%;padding:10px"></textarea>
                                    </b-field>
                                    <b-field label="Host">
                                        <b-input v-model="mailview.host"></b-input>
                                    </b-field>
                                    <b-field label="PortExit">
                                        <b-input type="number" v-model="mailview.portExit"></b-input>
                                    </b-field>
                                    <b-field label="Mail delivery time">
                                        <b-timepicker rounded
                                                      placeholder="Click to select..."
                                                      icon="clock"
                                                      hour-format="24" v-model="mailview.maildeliverytime">
                                        </b-timepicker>
                                    </b-field>
                                    <b-field label="Frequencyminute (Read mails)">
                                        <b-input type="number" v-model="mailview.frequencyminute"></b-input>
                                    </b-field>
                                    <br>
                                    <div class="level">
                                        <div class="level-left">
                                            <b-button type="is-warning" @click="putConfigEmail(mailview.id)">Update</b-button>
                                        </div>
                                        <div class="level-right buttons">
                                            <b-button type="is-success" @click="sendMail()">Force Send mails</b-button>
                                            <b-button type="is-success" @click="readMail()">Force Read mails</b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Nav from '@/components/Nav.vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        components: {
            Nav,
            Loading
        },
        data() {
            return {
                mailview: {},
                isBusy: false,
            }
        },
        created() {
            const self = this;
            this.$store.dispatch('verifyAccess').then(() => {
                self.LoadConfigEmail();
            });
        },
        methods: {
            LoadConfigEmail() {
                const self = this;
                this.isBusy = true;
                this.$store.dispatch('getConfigEmail').then(response => {
                    const genericResponse = response.data;
                    if (genericResponse.isError == true) {
                        this.$buefy.notification.open({
                            message: `Error: ${genericResponse.messageError}`,
                            position: 'is-bottom-right',
                            type: 'is-danger',
                            hasIcon: true,
                        })
                        self.isBusy = false;
                        return;
                    }
                    self.mailview = genericResponse.result[0];
                    self.mailview.maildeliverytime = new Date(1999, 1, 1, parseInt(self.mailview.maildeliverytime.split(':')[0]), parseInt(self.mailview.maildeliverytime.split(':')[1]))
                    self.isBusy = false;
                }).catch(error => {
                    this.$buefy.notification.open({
                        message: `Error: ${error.message}`,
                        position: 'is-bottom-right',
                        type: 'is-danger',
                        hasIcon: true,
                    })
                    self.isBusy = false;
                });
            },
            putConfigEmail(id) {
                const self = this;
                self.isBusy = true;
                this.axios
                    .put(`/mail/configupt/${id}`, {
                        user: this.mailview.user,
                        password: this.mailview.password,
                        portEntry: this.mailview.portEntry,
                        tls: this.mailview.tls,
                        authTimeout: this.mailview.authTimeout,
                        templateBody: this.mailview.templateBody,
                        host: this.mailview.host,
                        portExit: this.mailview.portExit,
                        frequencyminute: this.mailview.frequencyminute,
                        maildeliverytime: `${this.mailview.maildeliverytime.getHours()}:${this.mailview.maildeliverytime.getMinutes()}`,
                    })
                    .then(response => {
                        const genericResponse = response.data;
                        if (genericResponse.isError) {
                            this.$buefy.notification.open({
                                message: `Error: ${genericResponse.messageError}`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                        } else if (genericResponse.isError == false) {
                            this.$buefy.notification.open({
                                message: `Update mail`,
                                position: 'is-bottom-right',
                                type: 'is-success',
                                hasIcon: true,
                            });
                        }
                        self.isBusy = false;
                    })
                    .catch(error => {
                        this.isBusy = false;
                        console.error({ error })
                        this.$buefy.notification.open({
                            message: `Something Goes Wrong. Try Again.`,
                            position: 'is-bottom-right',
                            type: 'is-danger',
                            hasIcon: true,
                        })
                        self.isBusy = false;
                    })
            },
            sendMail() {
                const self = this;
                self.isBusy = true;
                this.axios
                    .get(`/mail/sendManualMail`)
                    .then(response => {
                        const genericResponse = response.data;
                        if (genericResponse.isError) {
                            this.$buefy.notification.open({
                                message: `Error: ${genericResponse.messageError}`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                        } else if (genericResponse.isError == false) {
                            this.$buefy.notification.open({
                                message: `Mails sent with success`,
                                position: 'is-bottom-right',
                                type: 'is-success',
                                hasIcon: true,
                            });
                        }
                        self.isBusy = false;
                    })
            },
            readMail() {
                const self = this;
                self.isBusy = true;
                this.axios
                    .get(`/mail/forceReadMails`)
                    .then(response => {
                        const genericResponse = response.data;
                        if (genericResponse.isError) {
                            this.$buefy.notification.open({
                                message: `Error: ${genericResponse.messageError}`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                        } else if (genericResponse.isError == false) {
                            this.$buefy.notification.open({
                                message: `${genericResponse.messageError} (${genericResponse.result.length} new mails imported)`,
                                position: 'is-bottom-right',
                                type: 'is-success',
                                hasIcon: true,
                            });
                        }
                        self.isBusy = false;
                    })
            }
        },
    }
</script>
<style lang="scss" scope>

    .card .content {
        font-size: 14px;
    }

    .card-footer-item {
        font-size: 14px;
        font-weight: 700;
        color: #8f99a3;
    }

    .card-table .table {
        margin-bottom: 0;
    }

    .events-card .card-table {
        max-height: 250px;
        overflow-y: scroll;
    }
</style>
